/* ═══ QUIZ TRACKER ═══ */
class QuizTracker {
  constructor() {
    this.sessionId = Math.random().toString(36).substring(2, 10);
    this.startTime = Date.now();
    this.slideTimestamps = {};
    this.currentSlide = 0;
    this.maxSlideReached = 0;
    this.answerChanges = {};
    this.answers = {};
    this.completed = false;
    const cfg = document.getElementById("quiz-tracking-config");
    this.webhookUrl = cfg ? cfg.dataset.webhook : "";
    this.metaPixel = cfg ? cfg.dataset.metaPixel === "true" : false;
    this.ga4 = cfg ? cfg.dataset.ga4 === "true" : false;
    this.variant = cfg ? cfg.dataset.variant : "";
    this.totalSlides = cfg ? parseInt(cfg.dataset.totalSlides) || 0 : 0;
    this.device = /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop";
    this.viewportWidth = window.innerWidth;
    this.referrer = document.referrer || "";
    this.utmParams = this._getUtmParams();
    window.addEventListener("beforeunload", () => { if (!this.completed) this.track("quiz_abandon", { last_slide: this.currentSlide, max_slide_reached: this.maxSlideReached, slides_seen: Object.keys(this.slideTimestamps).length, total_slides: this.totalSlides, time_spent_seconds: Math.round((Date.now() - this.startTime) / 1000), engagement_score: Math.round((this.maxSlideReached / Math.max(this.totalSlides, 1)) * 100) }); });
  }
  _getUtmParams() {
    const p = new URLSearchParams(window.location.search);
    const u = {}; ["utm_source","utm_medium","utm_campaign","utm_content","utm_term"].forEach(k => { if (p.get(k)) u[k] = p.get(k); });
    return u;
  }
  _basePayload() {
    return { session_id: this.sessionId, timestamp: new Date().toISOString(), quiz_variant: this.variant, device: this.device, viewport_width: this.viewportWidth };
  }
  track(eventType, data) {
    const payload = { ...this._basePayload(), event_type: eventType, ...data };
    if (this.webhookUrl) {
      try {
        // Image pixel GET request — no CORS, no redirects, works everywhere
        var img = new Image();
        img.src = this.webhookUrl + "?data=" + encodeURIComponent(JSON.stringify(payload)) + "&t=" + Date.now();
      } catch(e) {}
    }
    if (this.metaPixel && typeof fbq === "function") {
      try { fbq("trackCustom", "Quiz_" + eventType, payload); } catch(e) {}
    }
    if (this.ga4 && typeof gtag === "function") {
      try { gtag("event", "quiz_" + eventType, { ...data, session_id: this.sessionId, quiz_variant: this.variant }); } catch(e) {}
    }
    if (window.console) console.log("[QuizTrack]", eventType, payload);
  }
  trackSlideView(slideIndex, slideType, slideTitle) {
    const now = Date.now();
    const prevSlide = this.currentSlide;
    const timeOnPrev = this.slideTimestamps[prevSlide] ? Math.round((now - this.slideTimestamps[prevSlide]) / 1000) : 0;
    this.currentSlide = slideIndex;
    this.slideTimestamps[slideIndex] = now;
    if (slideIndex > this.maxSlideReached) this.maxSlideReached = slideIndex;
    this.track("slide_view", { slide_index: slideIndex, slide_type: slideType, slide_title: slideTitle || "", prev_slide: prevSlide, time_on_prev_slide_seconds: timeOnPrev, max_slide_reached: this.maxSlideReached });
  }
  trackAnswer(questionIndex, questionText, answerValues, questionType) {
    if (!this.answerChanges[questionIndex]) this.answerChanges[questionIndex] = 0;
    this.answerChanges[questionIndex]++;
    this.answers[questionIndex] = answerValues;
    this.track("answer", { question_index: questionIndex, question_text: questionText, answer_values: answerValues, question_type: questionType, answer_change_count: this.answerChanges[questionIndex], time_on_slide_seconds: this.slideTimestamps[questionIndex] ? Math.round((Date.now() - this.slideTimestamps[questionIndex]) / 1000) : 0 });
  }
  trackStart() { this.track("quiz_start", { page_url: window.location.href, referrer: this.referrer, utm: this.utmParams, total_slides: this.totalSlides }); }
  trackBack(fromSlide, toSlide) { this.track("back_button", { from_slide: fromSlide, to_slide: toSlide }); }
  trackPopup(popupId, response) { this.track("popup_response", { popup_id: popupId, response: response }); }
  trackComplete() {
    this.completed = true;
    this.track("quiz_complete", { total_time_seconds: Math.round((Date.now() - this.startTime) / 1000), total_slides_seen: Object.keys(this.slideTimestamps).length, total_slides: this.totalSlides, max_slide_reached: this.maxSlideReached, engagement_score: 100, all_answers: this.answers });
  }
  trackCTA(url) { this.track("cta_click", { cta_url: url, total_time_seconds: Math.round((Date.now() - this.startTime) / 1000) }); }
}

/* ═══ QUIZ NAVIGATION ═══ */
if (document.querySelector(".shopify-section.section-undereye-quiz")) {
  const quizBlocks = document.querySelectorAll(".shopify-section.section-undereye-quiz .quiz-block:not(.quiz-submit-block)");
  const tracker = new QuizTracker();
  var quizStarted = false;

  function getSlideInfo(block) {
    return { index: parseInt(block.dataset.index) || 0, type: block.dataset.blockType || "unknown", title: (block.querySelector("h2") || {}).textContent || "" };
  }
  function getSelectedAnswers(block) {
    const checked = block.querySelectorAll("input:checked");
    return Array.from(checked).map(c => c.value);
  }

  // Track first slide view
  var firstBlock = document.querySelector(".shopify-section.section-undereye-quiz .quiz-block.visible");
  if (firstBlock) { var fi = getSlideInfo(firstBlock); tracker.trackSlideView(fi.index, fi.type, fi.title); }

  quizBlocks.forEach((block) => {
    const interaction = block.dataset.question_interaction;

    // Track answer selections (for answer + answer_changed events)
    block.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
      input.addEventListener("change", function(e) {
        if (!quizStarted) { quizStarted = true; tracker.trackStart(); }
        var si = getSlideInfo(block);
        var vals = getSelectedAnswers(block);
        var qText = (block.querySelector("h2") || {}).textContent || "";
        tracker.trackAnswer(si.index, qText, vals, input.type);
      });
    });

    if (interaction === "oninputchange") {
      const inputs = block.querySelectorAll('input[type="radio"]');
      inputs.forEach((input) => {
        input.addEventListener("change", function (e) {
          e.stopPropagation();
          setTimeout(() => nextQuiz(block), 300);
        });
      });
    } else if (interaction === "ctaclick") {
      const btn = block.querySelector(".next_quiz");
      if (btn) {
        btn.addEventListener("click", function (e) {
          e.stopPropagation();
          if (!quizStarted) { quizStarted = true; tracker.trackStart(); }
          const checkboxes = block.querySelectorAll('input[type="checkbox"]:checked');
          const radios = block.querySelectorAll('input[type="radio"]:checked');
          if (block.dataset.blockType === "summery-block" || block.dataset.blockType === "results-block" || block.dataset.blockType === "goal-block" || block.dataset.blockType === "social-proof-block" || block.dataset.blockType === "education-block" || checkboxes.length > 0 || radios.length > 0) {
            if (block.classList.contains("last-block")) {
              submitBlockquestion(block);
            } else {
              nextQuiz(block);
            }
          }
        });
      }
    }
    const prevBtn = block.querySelector(".previous_quiz");
    if (prevBtn) {
      prevBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        var fromInfo = getSlideInfo(block);
        // Peek at history to get correct target for tracking
        var targetBlock = navHistory.length > 0 ? navHistory[navHistory.length - 1] : block.previousElementSibling;
        previewQuiz(block);
        if (targetBlock) { var toInfo = getSlideInfo(targetBlock); tracker.trackBack(fromInfo.index, toInfo.index); }
      });
    }
  });

  // Initialize progress bar
  updateProgress(0);

  // Navigation history stack for back-button support with branching
  var navHistory = [];
  var allBlocks = document.querySelectorAll(".shopify-section.section-undereye-quiz .quiz-block");

  function getSelectedAnswerIndex(block) {
    // Returns which answer number is selected (1-6) for branch rule matching
    var radios = block.querySelectorAll('input[type="radio"]');
    for (var r = 0; r < radios.length; r++) {
      if (radios[r].checked) return r + 1;
    }
    return 0;
  }

  function parseBranchRules(rulesStr) {
    // Parse "1>8, 2>5" into {1: 8, 2: 5}
    if (!rulesStr) return {};
    var rules = {};
    rulesStr.split(",").forEach(function(rule) {
      var parts = rule.trim().split(">");
      if (parts.length === 2) {
        var ansNum = parseInt(parts[0].trim());
        var target = parseInt(parts[1].trim());
        if (!isNaN(ansNum) && !isNaN(target)) rules[ansNum] = target;
      }
    });
    return rules;
  }

  function findBlockByIndex(targetIndex) {
    for (var b = 0; b < allBlocks.length; b++) {
      if (parseInt(allBlocks[b].dataset.index) === targetIndex) return allBlocks[b];
    }
    return null;
  }

  function goToBlock(fromBlock, targetBlock) {
    fromBlock.classList.remove("visible");
    fromBlock.classList.add("hidden");
    targetBlock.classList.remove("hidden");
    targetBlock.classList.add("visible");
    updateProgress(parseInt(targetBlock.dataset.index) - 1);
    var si = getSlideInfo(targetBlock);
    tracker.trackSlideView(si.index, si.type, si.title);
  }

  function nextQuiz(currentQuizBlock) {
    navHistory.push(currentQuizBlock);

    // Check for branch rules
    var rulesStr = currentQuizBlock.dataset.branchRules;
    if (rulesStr) {
      var rules = parseBranchRules(rulesStr);
      var selectedAns = getSelectedAnswerIndex(currentQuizBlock);
      if (selectedAns > 0 && rules[selectedAns]) {
        var targetBlock = findBlockByIndex(rules[selectedAns]);
        if (targetBlock) {
          tracker.track("branch", { from_slide: parseInt(currentQuizBlock.dataset.index), to_slide: rules[selectedAns], answer_index: selectedAns, rule: selectedAns + ">" + rules[selectedAns] });
          goToBlock(currentQuizBlock, targetBlock);
          return;
        }
      }
    }

    // Default: sequential next
    currentQuizBlock.classList.remove("visible");
    currentQuizBlock.classList.add("hidden");
    const nextQuizBlock = currentQuizBlock.nextElementSibling;
    if (nextQuizBlock && nextQuizBlock.classList.contains("quiz-block")) {
      nextQuizBlock.classList.remove("hidden");
      nextQuizBlock.classList.add("visible");
      updateProgress(parseInt(nextQuizBlock.dataset.index) - 1);
      var si = getSlideInfo(nextQuizBlock);
      tracker.trackSlideView(si.index, si.type, si.title);
    }
  }

  function previewQuiz(currentQuizBlock) {
    currentQuizBlock.classList.remove("visible");
    currentQuizBlock.classList.add("hidden");

    // Use history stack if available (handles branching correctly)
    if (navHistory.length > 0) {
      var previousBlock = navHistory.pop();
      previousBlock.classList.remove("hidden");
      previousBlock.classList.add("visible");
      updateProgress(parseInt(previousBlock.dataset.index) - 1);
      var si = getSlideInfo(previousBlock);
      tracker.trackSlideView(si.index, si.type, si.title);
    } else {
      // Fallback: sequential previous
      const previousQuizBlock = currentQuizBlock.previousElementSibling;
      if (previousQuizBlock && previousQuizBlock.classList.contains("quiz-block")) {
        previousQuizBlock.classList.remove("hidden");
        previousQuizBlock.classList.add("visible");
        updateProgress(parseInt(previousQuizBlock.dataset.index) - 1);
        var si2 = getSlideInfo(previousQuizBlock);
        tracker.trackSlideView(si2.index, si2.type, si2.title);
      }
    }
  }

  function updateProgress(totalNumberOfSteps) {
    var progressPercentage = (100 / document.querySelectorAll(".shopify-section.section-undereye-quiz .quiz-block").length) * totalNumberOfSteps;
    var topBar = document.getElementById("quiz-top-progress-bar");
    if (topBar) {
      topBar.ariaValueNow = progressPercentage;
      topBar.style.width = progressPercentage + "%";
    }
  }

  function submitBlockquestion(currentQuizBlock) {
    currentQuizBlock.classList.remove("visible");
    currentQuizBlock.classList.add("hidden");
    const nextQuizBlock = currentQuizBlock.nextElementSibling;
    if (nextQuizBlock && nextQuizBlock.classList.contains("quiz-block")) {
      nextQuizBlock.classList.remove("hidden");
      nextQuizBlock.classList.add("visible");
      var topBar = document.getElementById("quiz-top-progress-bar");
      if (topBar) { topBar.style.width = "100%"; topBar.ariaValueNow = 100; }
      tracker.trackSlideView(999, "processing", "Processing");
      window.firstProgress = new ProgressBar("first");
      window.secondProgress = new ProgressBar("second");
      window.thirdProgress = new ProgressBar("third");
      setTimeout(() => { firstProgress.activate(); firstProgress.startProgress(); }, 100);
    }
  }
}

class ProgressBar {
  constructor(id) {
    this.id = id; this.percentage = 0;
    this.intervalId = null; this.element = document.getElementById(id + "-progress"); this.isComplete = false;
    this.finalTitle = this.element ? (this.element.dataset.completeTitle || id) : id;
  }
  updateProgressBar() {
    const progressPath = this.element.querySelector(".progress-bar .progress");
    progressPath.style.strokeDashoffset = 100 - this.percentage;
    this.element.querySelector(".progress-percentage").textContent = this.percentage + "%";
    if (this.percentage >= 100 && !this.isComplete) this.completeProgress();
  }
  completeProgress() {
    this.isComplete = true;
    this.element.querySelector(".progress-title").textContent = this.finalTitle;
    this.element.querySelector(".progress-percentage").style.display = "none";
    this.element.querySelector(".check-icon").style.display = "block";
    clearInterval(this.intervalId);
    const event = new Event("progressComplete");
    this.element.dispatchEvent(event);
    if (this.id === "third") {
      if (typeof tracker !== "undefined") tracker.trackComplete();
      const targetButton = document.querySelector(".quiz-submit-block .generic-button");
      if (targetButton) {
        var interaction = document.querySelector("#submit-block").dataset.question_interaction;
        if (interaction == "direct") { if (typeof tracker !== "undefined") tracker.trackCTA(targetButton.href); window.location.href = targetButton.href; }
        else {
          targetButton.classList.remove("hidden");
          setTimeout(() => { targetButton.style.opacity = "1"; }, 10);
          targetButton.addEventListener("click", function() { if (typeof tracker !== "undefined") tracker.trackCTA(targetButton.href || targetButton.getAttribute("href") || ""); }, { once: true });
        }
      }
    }
  }
  showPopup() {
    const p = document.getElementById(this.id + "Popup");
    const o = document.getElementById(this.id + "PopupOverlay");
    p.style.display = "block"; o.style.display = "block";
    p.offsetHeight; p.classList.add("visible"); o.classList.add("visible");
  }
  hidePopup() {
    const p = document.getElementById(this.id + "Popup");
    const o = document.getElementById(this.id + "PopupOverlay");
    p.classList.remove("visible"); o.classList.remove("visible");
    setTimeout(() => { p.style.display = "none"; o.style.display = "none"; }, 300);
  }
  activate() { this.element.classList.add("visible"); }
  startProgress() {
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      if (this.percentage >= 100) { clearInterval(this.intervalId); this.completeProgress(); return; }
      if (this.percentage === 49) { clearInterval(this.intervalId); this.showPopup(); return; }
      this.percentage++; this.updateProgressBar();
    }, 75);
  }
  continueProgress() { this.hidePopup(); this.percentage++; this.startProgress(); }
}

window.continueProgress = function(which) {
  var popupId = which;
  var btn = event && event.target ? event.target : null;
  var response = btn ? (btn.classList.contains("fPopY") ? "yes" : "no") : "unknown";
  if (typeof tracker !== "undefined") tracker.trackPopup(popupId, response);
  if (which === "first") {
    firstProgress.continueProgress();
    firstProgress.element.addEventListener("progressComplete", () => {
      setTimeout(() => { secondProgress.activate(); secondProgress.startProgress(); }, 1000);
    }, { once: true });
  } else if (which === "second") {
    secondProgress.continueProgress();
    secondProgress.element.addEventListener("progressComplete", () => {
      setTimeout(() => { thirdProgress.activate(); thirdProgress.startProgress(); }, 1000);
    }, { once: true });
  } else { thirdProgress.continueProgress(); }
};